import { Container, Stack, Text, Title } from '@mantine/core';

export function DashboardPage() {
	return (
		<Container
			size="xl"
			py="xl"
			style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
		>
			<Stack gap="xl" style={{ flex: 1 }}>
				{/* Header */}
				<div>
					<Title order={2}>Manufacturer Dashboard</Title>
					<Text c="dimmed" size="sm" mt="xs">
						Welcome to your manufacturer platform
					</Text>
				</div>
			</Stack>
		</Container>
	);
}
